export default __webpack_public_path__ + "static/media/items.b5c270f5.svg";